module.exports = __webpack_public_path__ + "img/bg_ai_intelligent.0cca54e3.png";